import { List as IList } from 'immutable';

export const selectHomepageProducts = (state) => state.homepageContentReducer.get('products', IList());
export const selectHomepageDemands = (state) => state.homepageContentReducer.get('demands', IList());
export const selectFeaturedProducts = (state) => state.homepageContentReducer.get('featuredProducts', IList());
